import React from 'react'
import debounce from 'lodash/debounce'

import { useEffect, useLocalStorage, useMemo } from 'src/hooks'

type PersistStateProps = {
  name: string
  data: Object
  onMount: (data: object) => void
}

const PersistState: React.FC<PersistStateProps> = props => {
  const { name, data, onMount } = props

  const storage = useLocalStorage()

  useEffect(() => {
    if (!storage) return
    const data = storage.getItem(name)
    data && onMount(JSON.parse(data))
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  const persist = useMemo(
    () =>
      debounce((key: string, value: Object) => {
        if (!storage) return
        storage.setItem(key, JSON.stringify(value))
      }, 500),
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [],
  )

  useEffect(() => {
    persist(name, data)
  }, [persist, name, data])

  return null
}

export default PersistState
